export default {
  common: {
    accept: 'OK',
    cancel: 'Cancelar',
    close: 'Fechar',
    save: 'Salvar',
    delete: 'Excluir',
    edit: 'Editar',
    copy: 'Copiar',
    retry: 'Tentar novamente',
    loading: 'Carregando…',
    search: 'Buscar',
    confirm: 'Confirmar',
    yes: 'Sim',
    no: 'Não',
    back: 'Voltar',
    none: 'Nenhum',
    all: 'Todos',
    clear: 'Limpar',
    refresh: 'Atualizar',
    prev: 'Anterior',
    next: 'Próximo',
    sending: 'Enviando…',
  },
  nav: {
    library: 'Biblioteca',
    import: 'Importar',
    cloud: 'Na nuvem',
    settings: 'Configurações',
    stats: 'Estatísticas',
    knowledge: 'Conhecimento',
    review: 'Revisão',
    discover: 'Descobrir',
    clubs: 'Clubes',
    notifications: 'Notificações',
    account: 'Conta',
    skipToContent: 'Pular para o conteúdo',
    openMenu: 'Abrir menu',
    closeMenu: 'Fechar menu',
    search: 'Buscar',
  },
  import: {
    title: 'Importar livros',
    subtitle: 'Adicione EPUBs à sua biblioteca. Os ficheiros são guardados apenas neste navegador.',
    dropTitle: 'Arraste os seus EPUBs para aqui',
    dropHint: 'ou clique para escolher ficheiros · pode importar vários de uma vez',
    lastReport: 'Última importação',
    reportImported: '{count} livro(s) importado(s) | {count} livro importado | {count} livros importados',
    reportSkipped: '{count} duplicado(s) ignorado(s) | {count} duplicado ignorado | {count} duplicados ignorados',
    reportFailed: '{count} com erro | {count} com erro | {count} com erro',
    goToLibrary: 'Ir para a biblioteca',
    helpTitle: 'Dicas',
    help1: 'Pode importar vários EPUBs de uma vez arrastando-os ou selecionando-os.',
    help2: 'Se um ficheiro já está na sua biblioteca (mesmo conteúdo), é ignorado automaticamente.',
    help3: 'Os ficheiros não são enviados para nenhum servidor; ficam no armazenamento local do navegador.',
  },
  shelves: {
    manage: 'Gerir estantes',
    manageHide: 'Ocultar gestão',
    createButton: 'Criar',
    createPlaceholder: 'Nome da estante…',
    descriptionPlaceholder: 'Descrição opcional…',
    pickColor: 'Escolher cor',
    noColor: 'Sem cor',
    bookCount: '{count} livro(s) | {count} livro | {count} livros',
    created: 'Estante «{name}» criada.',
    updated: 'Estante atualizada.',
    deleted: 'Estante «{name}» eliminada.',
    empty: 'Ainda não há estantes. Crie a primeira acima.',
    addToShelf: 'Adicionar à estante',
    inShelves: 'Nas estantes',
    none: 'Nenhuma',
    organize: {
      button: 'Organizar por metadados',
      title: 'Organizar por metadados',
      intro: 'Crie estantes automaticamente agrupando os seus livros por um campo.',
      field: 'Agrupar por',
      'field.author': 'Autor',
      'field.publisher': 'Editora',
      'field.language': 'Idioma',
      'field.collection': 'Série',
      mode: 'Se já existe uma estante com esse nome',
      'mode.merge': 'Combinar (adicionar sem remover)',
      'mode.replace': 'Substituir (esvaziar e preencher)',
      preview: 'Pré-visualização',
      previewSummary:
        '{created} {created, plural, =0 {estantes novas serão criadas} one {estante nova será criada} other {estantes novas serão criadas}}, {updated} {updated, plural, one {estante existente} other {estantes existentes}} {updated, plural, =0 {serão atualizadas} one {será atualizada} other {serão atualizadas}} e {skipped} {skipped, plural, one {livro sem valor} other {livros sem valor}} {skipped, plural, =0 {serão ignorados} one {será ignorado} other {serão ignorados}}.',
      emptyGroups: 'Não há grupos para os livros e campo atuais.',
      apply: 'Aplicar',
      applying: 'A aplicar…',
      cancel: 'Cancelar',
      result:
        '{created} {created, plural, one {estante} other {estantes}} {created, plural, =0 {criadas} one {criada} other {criadas}}, {updated} atualizadas.',
    },
    reextract: {
      button: 'Gerar etiquetas a partir dos EPUBs',
      confirmTitle: 'Gerar etiquetas a partir dos EPUBs',
      confirmMessage:
        'Relê cada EPUB e adiciona os seus géneros (<dc:subject>) às etiquetas, sem substituir as existentes. Só processa livros com ficheiro local. Pode demorar em bibliotecas grandes.',
      apply: 'Gerar',
      applying: 'A gerar…',
      result:
        'Etiquetas atualizadas em {updated} {updated, plural, one {livro} other {livros}}, {unchanged} sem alterações, {missing} sem ficheiro local e {failed} {failed, plural, one {falha} other {falhas}}.',
    },
  },
  cloud: {
    title: 'Na nuvem',
    subtitle: '{count} livro(s) na nuvem | {count} livro na nuvem | {count} livros na nuvem',
    searchPlaceholder: 'Procurar por título ou autor…',
    hideLocal: 'Ocultar os que já estão neste dispositivo',
    refresh: 'Atualizar',
    extractCovers: 'Recuperar capas',
    extractCoversHint: 'Extrair as capas dos livros que não as têm (processado no servidor)',
    extractCoversStarting: 'A recuperar capas da nuvem…',
    extractCoversRunning: 'A recuperar…',
    extractCoversDone: '{n} capa(s) recuperada(s).',
    extractCoversPartial: 'Recuperadas {ok}, falharam {fail}.',
    extractCoversFailed: 'Não foi possível recuperar nenhuma capa.',
    extractCoversNothing: 'Todas as capas já estavam presentes.',
    loading: 'A carregar a biblioteca da nuvem…',
    empty: 'Ainda não tem livros na nuvem.\nEnvie um a partir do detalhe de um livro para o ver aqui noutros dispositivos.',
    emptyFiltered: 'Nenhum livro corresponde à pesquisa ou ao filtro.',
    onDevice: 'Neste dispositivo',
    downloading: 'A descarregar…',
    download: 'Descarregar',
    // Ação principal: abre o livro para ler ao instante (descarga
    // transparente em segundo plano). É o novo fluxo predefinido.
    read: 'Ler',
    opening: 'A abrir…',
    // "Guardar offline" explícito: descarrega o livro sem o abrir, para
    // o ter disponível sem ligação (p. ex. uma viagem de avião).
    saveOffline: 'Guardar offline',
    savingOffline: 'A guardar…',
    prev: 'Anterior',
    next: 'Seguinte',
    pageOf: 'Página {page} de {total}',
    signInPrompt: 'Inicie sessão e ative a sincronização para ver os seus livros na nuvem.',
    goToAuth: 'Iniciar sessão',
    goToSettings: 'Ir para Configurações',
    uploadAll: 'Enviar todos locais',
    uploadAllHint: 'Enviar {n} livro(s) da sua biblioteca para a nuvem',
    uploadFiles: 'Enviar ficheiros',
    uploadNothing: 'Não há livros locais pendentes de envio.',
    uploadStarting: 'A enviar {n} livro(s) para a nuvem…',
    uploadingItem: 'A enviar {current} de {total}',
    uploadFinished: 'Envio concluído',
    uploadAllDone: '{n} livro(s) enviado(s) para a nuvem.',
    uploadPartial: 'Enviados {ok}, falharam {fail}. Veja os detalhes.',
    uploadFailed: 'Não foi possível enviar nenhum livro.',
    uploadAlreadyRunning: 'Já há um envio em curso.',
    deleteFromCloud: 'Excluir da nuvem',
    deleteConfirm: 'Excluir "{title}" da nuvem?\n\nA cópia local neste dispositivo não será removida.',
    deleted: 'Livro excluído da nuvem.',
    fileTooLarge: 'O arquivo tem {size} MB. O limite por arquivo na nuvem é 50 MB.',
    // Modo seleção (exclusão em lote da nuvem)
    selectMode: 'Selecionar',
    exitSelection: 'Sair',
    selectAll: 'Selecionar tudo',
    clearSelection: 'Limpar',
    cancelSelection: 'Cancelar',
    selectedCount: '{n} selecionado(s)',
    deleteSelected: 'Excluir',
    deleteSelectedConfirm:
      'Excluir {n} livro(s) da nuvem?\n\nAs cópias locais nos seus dispositivos não serão removidas. Apenas as cópias na nuvem serão excluídas.',
    deletedMany: '{n} livro(s) excluído(s) da nuvem.',
    deletePartial: 'Excluídos {ok}, falharam {fail}. Verifique a lista.',
    deleteFailed: 'Não foi possível excluir nenhum livro da nuvem.',
  },
  search: {
    title: 'Pesquisar na biblioteca',
    placeholder: 'Pesquise no conteúdo dos seus livros e anotações…',
    searching: 'A pesquisar…',
    noResults: 'Sem resultados.',
    resultsCount: '{count} resultado(s) | {count} resultado | {count} resultados',
    groupBook: 'Livro',
    groupHighlight: 'Anotação',
    openInReader: 'Abrir no leitor',
    chapter: 'Capítulo',
    annotation: 'Anotação',
    shortcutHint: 'Prima Ctrl/⌘+K para pesquisar',
    indexingBooks: 'A indexar biblioteca…',
    migrationProgress: 'A indexar {done} de {total} livros…',
    migrationDone: 'Biblioteca indexada.',
    openButton: 'Pesquisar conteúdo',
  },
  knowledge: {
    title: 'Conhecimento',
    subtitle: 'As suas anotações agrupadas em temas e ligadas entre si.',
    themesCount: '{count} tema(s) | {count} tema | {count} temas',
    memberCount: '{count} anotação(ões) | {count} anotação | {count} anotações',
    analyzing: 'A analisar as suas anotações…',
    empty: 'Ainda não há temas. Crie mais anotações para surgirem conexões.',
    noEmbeddings: 'Para gerar temas e conexões semânticas precisa de um fornecedor de embeddings (OpenAI ou Ollama).',
    embeddingNeeded: 'Ir para Configurações',
    backlinks: 'Ligam para aqui',
    related: 'Relacionados',
    relatedEmpty: 'A procurar relacionados…',
    connections: 'Conexões',
    aliasNotFound: 'Nenhuma nota encontrada para «{alias}».',
    wikiHint: 'Escreva [[alias]] nas suas notas para as ligar entre si.',
  },
  rag: {
    askBook: 'Perguntar ao livro',
    askLibrary: 'Perguntar à biblioteca',
    placeholder: 'Pergunte sobre o conteúdo…',
    thinking: 'A pensar…',
    cited: 'Respostas fundamentadas com citações',
    jumpToCitation: 'Ir para a passagem citada',
    jumpFailed: 'Não foi possível ir para a citação: {reason}',
    bookNotFound: 'O livro citado já não está na biblioteca.',
    noAnswer: 'Não encontrei informação sobre isso no contexto.',
    needsEmbeddings: 'Esta função requer um fornecedor de embeddings (OpenAI ou Ollama) em Configurações → IA.',
    crossSummary: 'Resumo cruzado',
    selectBook1: 'Livro 1',
    selectBook2: 'Livro 2',
    topic: 'Tema a comparar',
    topicPlaceholder: 'ex. atenção, memória, liberdade…',
    generate: 'Gerar',
    crossUserPrompt: 'Compare como estes dois livros tratam o tema indicado.',
    crossFailed: 'Não foi possível gerar o resumo cruzado: {reason}',
  },
  librarian: {
    badge: 'Bibliotecário',
    intro: 'Sou O Bibliotecário. Pergunte-me recomendações: «o que leio depois de terminar X?», «algo curto de ficção científica», «parecido a Y»…',
  },
  review: {
    title: 'Revisão',
    subtitle: 'Revise as suas anotações com repetição espaçada para as reter.',
    empty: 'Ainda não tem cartões de revisão.',
    emptyHint: 'Abra um livro, marque um texto e toque no botão de revisão (⏰) nas suas anotações.',
    start: 'Começar revisão',
    queue: 'Fila',
    ofN: 'de {total}',
    done: 'revistas',
    completed: 'Sessão concluída!',
    showAnswer: 'Mostrar resposta',
    again: 'De novo',
    hard: 'Difícil',
    good: 'Bem',
    easy: 'Fácil',
    dueToday: 'vencidas hoje',
    filters: 'Filtros',
    allBooks: 'Todos os livros',
    allColors: 'Todas as cores',
    onlyDue: 'Só vencidas',
    addToReview: 'Adicionar à revisão',
    removeFromReview: 'Remover da revisão',
    generateQuestion: 'Gerar pergunta',
    questionReady: 'Pregunta pronta',
    noCards: 'Nenhum cartão corresponde a estes filtros.',
  },
  share: {
    title: 'Leitura partilhada',
    createLink: 'Criar ligação de leitura',
    createFailed: 'Não foi possível criar a ligação partilhada.',
    linkCopied: 'Ligação copiada para a área de transferência. Partilhe-a com o seu clube de leitura.',
    hint: 'Quem abrir a ligação verá as anotações deste livro em tempo real e poderá descarregá-lo.',
    accepting: 'A aceitar convite…',
    downloading: 'A descarregar livro partilhado…',
    inviteAccepted: 'Juntou-se à leitura partilhada.',
    inviteAcceptedHint: 'O livro foi adicionado à sua biblioteca. Abra-o para ver e adicionar anotações conjuntas.',
    inviteFailed: 'Não foi possível juntar-se à leitura. A ligação pode ter expirado.',
    missingShare: 'Falta o identificador do convite na ligação.',
    redirecting: 'A levá-lo para a sua biblioteca…',
    retry: 'Tentar novamente',
    goToLibrary: 'Ir para a biblioteca',
    memberHint: 'Recebeu este livro por convite. As anotações sincronizam em tempo real com quem o partilhou.',
    leaveShare: 'Sair do livro partilhado',
    leaveShareConfirmBody: 'Sair deste livro partilhado? Será removido da sua biblioteca. Pode voltar a juntar-se com a ligação de convite.',
    leaveDone: 'Saiu do livro partilhado.',
    leaveFailed: 'Não foi possível sair do livro partilhado. Tente novamente.',
    roles: { owner: 'Dono', annotator: 'Anotador', viewer: 'Leitor' },
    viewerHint: 'Está em modo só de leitura. Não pode adicionar anotações nem comentários.',
    inviteByEmail: 'Ou convidar por email',
    emailPlaceholder: "amigo{'@'}dominio.com",
    sendInvite: 'Enviar convite',
    inviteSent: 'Convite enviado para {email}.',
  },
  discover: {
    title: 'Descobrir',
    subtitle: 'Citações que outros leitores partilharam publicamente.',
    empty: 'Ainda não há citações públicas. Partilhe uma a partir das suas anotações.',
    loadMore: 'Carregar mais',
    noMore: 'Não há mais citações.',
    scopeGlobal: 'Global',
    scopeFollowing: 'A seguir',
    sortRecent: 'Recentes',
    sortTop: 'Top',
    report: 'Denunciar',
    reported: 'Denunciado. Obrigado.',
    reportFailed: 'Não foi possível denunciar.',
    reportPlaceholder: 'Por que está a denunciar?',
    sendReport: 'Enviar denúncia',
    publishAction: 'Publicar em Descobrir',
    published: 'Publicado em Descobrir (clique para remover)',
    publishedToast: 'Citação publicada em Descobrir.',
    unpublished: 'Citação removida do feed público.',
    publishFailed: 'Não foi possível publicar a cita.',
  },
  library: {
    title: 'Biblioteca',
    heroEyebrow: 'Seu cantinho de leitura',
    import: 'Importar',
    importHint: 'Arraste arquivos EPUB aqui ou clique para selecionar',
    imported: '{count} livro(s) importado(s) | {count} livro importado | {count} livros importados',
    importFailed: 'Não foi possível importar "{name}": {reason}',
    deleted: 'Livro removido da biblioteca',
    empty: 'Sua biblioteca está vazia. Importe um EPUB para começar.',
    searchPlaceholder: 'Buscar por título ou autor…',
    filterAll: 'Todos',
    filterUnread: 'Não lidos',
    filterReading: 'Lendo',
    filterFinished: 'Lidos',
    sortByRecent: 'Recentes',
    sortByTitle: 'Título',
    sortByAuthor: 'Autor',
    sortByProgress: 'Progresso',
    cover: 'Capa',
    open: 'Abrir',
    importing: 'Importando livros…',
    loadingLibrary: 'Carregando biblioteca…',
    allTags: 'Todas',
    allShelves: 'Todas',
    noMatches: 'Nenhum livro corresponde aos filtros atuais.',
    bookCount: '{count} livro(s) no total | {count} livro no total | {count} livros no total',
    errorLabel: 'Erro: {message}',
    continueReading: 'Continuar a ler',
    continueButton: 'Continuar',
    sectionReading: 'Lendo',
    sectionNotStarted: 'Por começar',
    sectionRecentlyFinished: 'Terminados recentemente',
    sectionFavorites: 'Favoritos',
    sectionAll: 'Sua coleção',
    sectionResults: 'Resultados',
    sectionCloud: 'Na nuvem',
    sectionCloudHint: 'Seus livros que não estão neste dispositivo',
    viewAllCloud: 'Ver toda a nuvem',
    alsoInCloud: 'Disponível na nuvem',
    cloudOnly: 'Apenas na nuvem',
    viewCloudManagement: 'Gerir na nuvem',
    loadMore: 'Carregar mais',
    density: 'Densidade da grelha',
    density_compact: 'Compacto',
    density_comfortable: 'Confortável',
    density_list: 'Lista',
    importSkipped: '“{name}” já está na sua biblioteca como “{existing}”. Ignorado.',
    deleteBook: 'Remover da biblioteca',
    favorite: 'Marcar como favorito',
    unfavorite: 'Remover dos favoritos',
    addedToFavorites: 'Adicionado aos favoritos',
    favorites: 'Favoritos',
    favoritesHint: 'Ver apenas os seus livros favoritos',
    removedFromFavorites: 'Removido dos favoritos',
    sharedChip: 'Partilhados',
    sharedBadge: 'Livro partilhado',
    uploadToCloud: 'Enviar para a nuvem',
    uploadedToCloud: 'Enviado para a nuvem',
    alreadyInCloud: 'Já na nuvem',
    addToShelf: 'Adicionar à estante',
    shelvesEmpty: 'Você não tem estantes. Crie-as em Ajustes.',
    // Índice alfabético (A-Z)
    alphaIndex: 'Índice alfabético',
    alphaAll: 'Todas',
    alphaOther: '#',
    alphaModeTitle: 'Títulos',
    alphaModeAuthor: 'Autores',
    // Modo seleção (exclusão em lote da biblioteca)
    selectMode: 'Selecionar',
    exitSelection: 'Sair',
    selectAll: 'Selecionar tudo',
    clearSelection: 'Limpar',
    cancelSelection: 'Cancelar',
    selectedCount: '{n} selecionado(s)',
    deleteSelected: 'Excluir',
    deleteSelectedConfirm:
      'Excluir {n} livro(s) da sua biblioteca?\n\nEsta ação não pode ser desfeita. Suas anotações, resumos e progresso de leitura também serão removidos.',
    deletedMany: '{n} livro(s) excluído(s)',
    deleteFromCloudToo: 'Excluir também da nuvem ({uploaded} de {total} estão enviados)',
  },
  onboarding: {
    title: 'Bem-vindo ao EPUB Unlimited',
    subtitle: 'Seu cantinho de leitura offline-first com anotações, IA e sync entre dispositivos. Comece importando seu primeiro livro.',
    importEpub: 'Importar EPUB',
    importEpubHint: 'Selecione um ou mais arquivos do seu dispositivo.',
    loadDemo: 'Carregar livro de exemplo',
    loadDemoHint: 'Baixa "Dom Quixote" (domínio público) para experimentar.',
    demoLoading: 'Baixando…',
    demoSuccess: 'Livro de exemplo carregado.',
    demoAlready: 'Você já tinha o livro de exemplo na sua biblioteca.',
    demoError: 'Não foi possível baixar o livro de exemplo. Verifique sua conexão.',
    offlineHint: 'Requer conexão com a internet.',
    configureSync: 'Configurar sync / IA',
    configureSyncHint: 'Ative a sincronização na nuvem e/ou seu provedor de IA.',
    importSuccess: '{n} livro(s) importado(s).',
    importSkipped: '{n} duplicado(s) ignorado(s).',
    importFailed: '{n} arquivo(s) falharam ao importar.',
    dismiss: 'Não mostrar novamente',
    showAgain: 'Mostrar guia de início',
  },
  bookDetail: {
    author: 'Autor',
    language: 'Idioma',
    publisher: 'Editora',
    isbn: 'ISBN',
    description: 'Sinopse',
    tags: 'Etiquetas',
    addTag: 'Adicionar etiqueta',
    collection: 'Coleção',
    status: 'Estado',
    rating: 'Avaliação',
    noRating: 'Sem avaliação',
    setRating: 'Avaliar com {n} estrela(s) | Avaliar com {n} estrela | Avaliar com {n} estrelas',
    editMetadata: 'Editar metadados',
    enrichMetadata: 'Melhorar metadados',
    enriching: 'A melhorar…',
    enriched: 'Metadados melhorados: {fields}.',
    enrichFailed: 'Não foi possível melhorar os metadados: {reason}',
    alreadyComplete: 'Os metadados já estavam completos.',
    titleLabel: 'Título',
    authorLabel: 'Autor',
    changeCover: 'Alterar capa',
    coverNotImage: 'O arquivo selecionado não é uma imagem.',
    coverUpdated: 'Capa atualizada.',
    progress: 'Progresso',
    openBook: 'Ler',
    deleteBook: 'Excluir',
    deleteConfirm: 'Excluir este livro? Esta ação não pode ser desfeita.',
    toggleSelect: 'Selecionar ou desmarcar este livro',
    cloud: 'Nuvem',
    uploadToCloud: 'Enviar para a nuvem',
    uploading: 'Enviando…',
    uploaded: 'Livro enviado para a nuvem.',
    downloadFromCloud: 'Baixar',
    downloaded: 'Livro baixado da nuvem.',
    inCloud: 'Na nuvem',
    removeFromCloud: 'Remover da nuvem',
    removeCloudConfirm: 'Remover este livro da nuvem?',
    removedFromCloud: 'Livro removido da nuvem.',
    citation: 'Citação',
    copyCitation: 'Copiar citação',
    citationCopied: 'Citação copiada para a área de transferência.',
    uploadFailed: 'Não foi possível enviar: {reason}',
    downloadFailed: 'Não foi possível baixar: {reason}',
    backToLibrary: '← Voltar para a biblioteca',
    loading: 'Carregando…',
    bookNotFound: 'Livro não encontrado.',
    continueReading: 'Continuar lendo',
    startReading: 'Começar a ler',
    statusLabel: 'Estado:',
    statusUnread: 'Para ler',
    statusReading: 'Lendo',
    statusFinished: 'Lido',
    details: 'Detalhes',
    publisherLabel: 'Editora:',
    languageLabel: 'Idioma:',
    isbnLabel: 'ISBN:',
    published: 'Publicado:',
    added: 'Adicionado:',
    removeTag: 'Remover etiqueta',
    addPlaceholder: 'Adicionar…',
    add: 'Adicionar',
    collectionLabel: 'Coleção / Série',
    collectionPlaceholder: 'Ex. Trilogia da Fundação',
    syncHint: 'Ative a sincronização em Configurações para enviar este livro à nuvem e lê-lo em outros dispositivos.',
    cloudRemoveFailed: 'Não foi possível remover: {reason}',
  },
  audio: {
    nowPlaying: 'A ouvir',
    play: 'Reproduzir',
    pause: 'Pausa',
    next: 'Seguinte',
    prev: 'Anterior',
    seekBack: 'Recuar {n} s',
    seekForward: 'Avançar {n} s',
    seekUnavailable: 'A voz do navegador não consegue saltar dentro do áudio: muda para neural',
    stop: 'Fechar reprodutor',
    openInReader: 'Abrir no leitor',
    miniBar: 'Reprodutor de audiolivro',
    rate: 'Velocidade',
    sleep: 'Temporizador para dormir',
    sleepOff: 'Sem temporizador',
    sleepMinutes: '{n} min',
    sleepChapter: 'Fim do capítulo',
    engine: 'Voz',
    engineBrowser: 'Navegador (gratuito)',
    engineNeural: 'Neural (audiolivro)',
    engineNeuralUnavailable: 'A voz neural requer OpenAI ou uma key do ElevenLabs em Ajustes → IA',
    voice: 'Voz neural',
    estimatedCost: 'Custo estimado deste livro: ~{usd} USD',
    browserEngineGone: 'A voz do navegador precisa do leitor aberto. Foi pausada.',
    switchToNeural: 'Mudar para neural',
    browserEngineGoneNoNeural: 'A voz do navegador precisa do leitor aberto. Reabra-o para continuar a ouvir.',
    backToReader: 'Voltar ao leitor',
    resumeUnavailable: 'Não há voz para continuar: abra o leitor ou mude para neural',
    cacheTitle: 'Cache de áudio',
    cacheHint: 'O áudio neural é guardado para não pagar duas vezes. ~1 MB por minuto.',
    cacheLimit: 'Limite da cache (MB)',
    cacheUsed: 'Ocupado: {mb} MB',
    cacheClear: 'Limpar cache de áudio',
    cacheClearConfirm: 'Todo o áudio já gerado dos teus livros será apagado. Ouvir outra vez irá sintetizá-lo (e cobrá-lo) de novo.',
    cacheCleared: 'Cache de áudio limpa',
    preparing: 'A preparar o áudio…',
    neuralNoText: 'Este livro não tem texto que a voz neural consiga ler. Voltou-se à voz do navegador.',
    neuralError: 'Não foi possível gerar o áudio: {reason}',
  },
  reader: {
    openingBook: 'Abrindo livro…',
    openError: 'Não foi possível abrir o livro.',
    notFound: 'Livro não encontrado.',
    toc: 'Índice',
    tocEmpty: 'Este livro não tem índice.',
    toggleToc: 'Abrir índice',
    searchInBook: 'Buscar no livro',
    searchResults: '{count} resultados',
    searchEmpty: 'Digite para buscar no livro.',
    searchPlaceholder: 'Texto para buscar…',
    searchProgress: 'Buscando…',
    searchEmptyHint: 'Digite um termo e pressione Buscar.',
    searchClear: 'Limpar resultados',
    chapter: 'Capítulo',
    pageNext: 'Próxima página',
    pagePrev: 'Página anterior',
    toolbarMore: 'Mais ferramentas',
    closeToolbar: 'Fechar',
    toolbarGroupNav: 'Navegação',
    toolbarGroupContent: 'Conteúdo',
    toolbarGroupAi: 'Inteligência artificial',
    toolbarGroupAppearance: 'Aparência',
    zen: 'Modo Zen',
    exitZen: 'Sair do Modo Zen',
    shortcutsTitle: 'Atalhos de teclado',
    shortcuts: {
      nextPage: 'Próxima página',
      prevPage: 'Página anterior',
      toggleToc: 'Abrir/fechar índice',
      toggleSearch: 'Abrir/fechar busca',
      toggleAnnotations: 'Abrir/fechar anotações',
      toggleZen: 'Ativar/desativar Modo Zen',
      toggleShortcuts: 'Mostrar este painel',
      closePopover: 'Fechar o popover de seleção',
    },
    appearance: 'Aparência e tipografia',
    layout: 'Disposição',
    flowPaginated: 'Paginado',
    flowScrolled: 'Rolagem contínua',
    searchAnnotations: 'Buscar nas anotações…',
    annotationsNoMatches: 'Nenhuma anotação corresponde à busca.',
    annotations: 'Anotações',
    annotationsEmpty: 'Ainda não há anotações neste livro.\nSelecione texto enquanto lê para destacar.',
    editNote: 'Editar nota',
    deleteAnnotation: 'Excluir anotação',
    comments: 'Comentários',
    commentPlaceholder: 'Escreva um comentário…',
    summaries: 'Resumos',
    summariesAction: 'Resumos com IA',
    viewSummaries: 'Ver resumos',
    chatAction: 'Conversa sobre o livro',
    openChat: 'Abrir conversa contextual',
    bilingual: 'Leitura bilingue',
    translate: 'Traduzir',
    bilingualEmpty: 'Prima «Traduzir» para ver a secção em dois idiomas.',
    landmarks: 'Índice',
    landmarksEmpty: 'Este livro não declara índice.',
    studyQuestions: 'Perguntas de estudo',
    generateQuestions: 'Gerar perguntas',
    studyEmpty: 'Prima «Gerar perguntas» para obter perguntas de compreensão do capítulo atual.',
    copyCitation: 'Copiar como citação',
    pomodoro: 'Pomodoro',
    pomodoroFocus: 'Foco',
    pomodoroBreak: 'Pausa',
    pomodoroLongBreak: 'Pausa longa',
    pomodoroStart: 'Começar',
    pomodoroPause: 'Pausar',
    pomodoroSkip: 'Saltar',
    summarizeHighlights: 'Resumir minhas anotações',
    noHighlightsToSummarize: 'Ainda não há anotações para resumir.',
    translations: 'Traduções',
    viewTranslations: 'Ver traduções',
    viewAnnotations: 'Ver anotações',
    bookmarks: 'Marcadores',
    bookmarksEmpty: 'Ainda não há marcadores.\nClique no ícone de marcador na barra superior para adicionar um.',
    toggleBookmark: 'Marcar/desmarcar página atual',
    addBookmarkHere: 'Marcar página atual',
    viewBookmarks: 'Ver marcadores',
    deleteBookmark: 'Excluir marcador',
    closeReader: 'Fechar leitura',
    tts: 'Ler em voz alta',
    ttsPrev: 'Fragmento anterior',
    ttsNext: 'Próximo fragmento',
    ttsPause: 'Pausar leitura',
    ttsPlay: 'Ler em voz alta',
    ttsStop: 'Parar leitura',
    ttsRate: 'Velocidade',
    ttsRateFull: 'Velocidade de leitura',
    ttsRateShort: 'Vel',
    ttsControls: 'Controles de leitura em voz alta',
    ttsUnsupported: 'Seu navegador não suporta leitura em voz alta.',
    ttsNotSupported: 'Seu navegador não suporta leitura em voz alta.',
    ttsStartFailed: 'Não foi possível iniciar a leitura: {reason}',
    colors: {
      yellow: 'Amarelo',
      green: 'Verde',
      blue: 'Azul',
      pink: 'Rosa',
      orange: 'Laranja',
    },
    highlightIn: 'Destacar em {color}',
    summarizeSelection: 'Resumir seleção com IA',
    explainSelection: 'Explicar seleção com IA',
    translateSelection: 'Traduzir seleção',
    bookmarkSelection: 'Marcar posição',
    defineWord: 'Definir palavra',
    addNote: 'Adicionar nota',
    selection: {
      highlight: 'Destacar',
      summarize: 'Resumir',
      explain: 'Explicar',
      translate: 'Traduzir',
      bookmark: 'Marcar',
      define: 'Definir',
    },
    annotationAdded: 'Destaque adicionado',
    annotationRemoved: 'Anotação removida',
    editAnnotation: 'Editar anotação',
    note: 'Nota',
    notePlaceholder: 'Escreva uma nota…',
    noteEdit: 'Editar',
    notePreview: 'Pré-visualizar',
    noteEmpty: 'Nada para pré-visualizar ainda.',
    color: 'Cor',
    bookmarkAdded: 'Marcador adicionado',
    bookmarkRemoved: 'Marcador removido',
    bookmarkLabel: 'Marcador',
    bookmarkNavigateHint: 'Navegue até uma página para marcá-la.',
    exportJson: 'Exportar JSON',
    exportMarkdown: 'Exportar MD',
    exportJsonDone: 'Anotações exportadas (JSON)',
    exportMarkdownDone: 'Anotações exportadas (Markdown)',
    importJson: 'Importar JSON',
    importDone: '{added} anotações importadas',
    importWithSkipped: '{added} importadas, {skipped} já existiam',
    importFailed: 'Importação falhou: {reason}',
    bookmarkFailed: 'Não foi possível marcar: {reason}',
    backToLibrary: 'Voltar para a biblioteca',
    regenerateError: 'Erro: {reason}',
  },
  ai: {
    requiresAuth: 'A IA requer início de sessão',
    requiresAuthHint: 'Inicie sessão com a sua conta para configurar e usar os recursos de inteligência artificial.',
    signIn: 'Iniciar sessão',
    summarizing: 'Gerando…',
    summarizingWait: 'Aguardando resposta do modelo…',
    summarizeChapter: 'Resumir capítulo',
    summarizeBook: 'Resumir livro',
    summaryDone: 'Resumo gerado',
    summaryChapterDone: 'Resumo do capítulo gerado',
    summaryBookDone: 'Resumo do livro gerado',
    explainDone: 'Explicação gerada',
    summaryFailed: 'Não foi possível gerar o resumo: {reason}',
    summaryHighlightsDone: 'Resumo das suas anotações gerado',
    explainFailed: 'Não foi possível gerar a explicação: {reason}',
    summaryEmpty: 'Não há texto neste capítulo para resumir.',
    summaryBookEmpty: 'Texto insuficiente para resumir o livro.',
    summaryRegenerated: 'Resumo regenerado',
    summaryCopied: 'Resumo copiado para a área de transferência',
    copyFailed: 'Não foi possível copiar.',
    error: {
      invalidKey: 'A API key não é válida. Verifique-a em Configurações → IA.',
      missingKey: 'Nenhuma API key configurada. Adicione uma em Configurações → IA.',
      quota: 'A sua conta ficou sem créditos ou atingiu o limite. Verifique o seu plano no provedor.',
      modelNotFound: 'O modelo configurado não está disponível. Altere-o em Configurações → IA.',
      network: 'Não foi possível contatar o provedor de IA. Verifique a sua conexão.',
    },
    chatTitle: 'Conversa sobre o livro',
    chatContextHint: 'Respostas com base no capítulo atual',
    chatEmpty: 'Faça uma pergunta sobre o que está lendo.\nAs respostas se baseiam no capítulo atual.',
    chatPlaceholder: 'Escreva uma pergunta…',
    chatSend: 'Enviar',
    chatNoChapter: 'Não há texto de capítulo disponível para basear a resposta.',
    chatFailed: 'Não foi possível responder: {reason}',
    summaryPanelEmpty: 'Ainda não há resumos.\nSelecione texto ou use os botões acima.',
    translating: 'Traduzindo…',
    translationDone: 'Tradução gerada',
    translationFailed: 'Não foi possível traduzir: {reason}',
    translationCopied: 'Tradução copiada',
    translationPanelEmpty: 'Ainda não há traduções.\nSelecione texto e pressione "Traduzir".',
    generatingCancelled: 'Geração cancelada.',
    dictionary: {
      title: 'Definição',
      searching: 'Buscando…',
      consulting: 'Consultando dicionário…',
      notFound: '"{word}" não foi encontrado no dicionário.',
      noResults: 'Sem resultados para "{word}".',
    },
    settings: {
      mode: 'Modo de conexão',
      direct: 'Direto',
      directDesc: 'Sua chave de API é armazenada apenas neste navegador.',
      proxy: 'Proxy',
      proxyDesc: 'A chave fica em um servidor (mais seguro).',
      proxyEndpoint: 'Endpoint do proxy',
      proxyPlaceholder: 'https://seu-worker.workers.dev',
      proxyToken: 'Token do proxy',
      proxyTokenPlaceholder: 'Deve coincidir com o APP_TOKEN do Worker',
      activeProvider: 'Provedor ativo',
      tts: 'Voz neural (audiolivro)',
      ttsHint: 'Quem sintetiza o áudio dos livros. O ElevenLabs usa a sua própria key e funciona com qualquer provedor ativo.',
      elevenLabsKey: 'API key do ElevenLabs',
      elevenLabsKeyHint: 'Vai direta deste navegador: o modo Proxy só encaminha o OpenAI.',
      generation: 'Geração',
      temperature: 'Temperatura (criatividade)',
      temperatureHint: 'Menor = mais fiel ao texto; maior = mais criativo.',
      summaryLanguage: 'Idioma dos resumos',
      syncedToAccount: 'Sincronizada com sua conta',
      localOnly: 'Apenas neste dispositivo',
      syncError: 'Erro ao sincronizar — veja Diagnóstico',
    },
    usage: {
      title: 'Uso de IA',
      today: 'Hoje',
      month: 'Este mês',
      tokens: 'tokens',
      empty: 'Você ainda não usou recursos de IA. Os tokens consumidos aparecerão aqui.',
      localHint: 'Modo offline: mostrando apenas a atividade local recente (não sincronizada).',
      refreshing: 'Atualizar',
    },
  },
  sync: {
    enabled: 'Sincronização',
    enable: 'Ativar sincronização',
    supabaseUrl: 'URL do Supabase',
    supabaseKey: 'Chave anônima (anon key)',
    connected: 'Sincronizado em tempo real',
    connecting: 'Conectando…',
    saving: 'Salvando na nuvem…',
    savingLabel: 'Salvando',
    syncLabel: 'Sync',
    offlineBanner: 'Sem conexão — as alterações são salvas localmente e serão sincronizadas ao voltar.',
    configRequired: 'Falta a configuração do Supabase (defina-a em .env.local).',
    envMissing: 'O Supabase não está configurado. Defina VITE_SUPABASE_URL e VITE_SUPABASE_PUBLISHABLE_KEY no arquivo .env.local do projeto e reinicie o servidor de desenvolvimento.',
    sessionActive: 'Sessão iniciada',
    sessionOk: 'Conexão correta — sessão ativa.',
    sessionOkNoSession: 'Conexão correta. Entre para sincronizar.',
    connectionFailed: 'Falha de conexão: {reason}',
    notSignedIn: 'Você não está conectado.',
    signInOrUp: 'Entrar / Registrar',
    projectUrl: 'URL do projeto',
    urlPlaceholder: 'https://xxxx.supabase.co',
    anonKey: 'Anon key',
    anonKeyHint: 'Encontre-a em Supabase → Settings → API. É pública (não é um segredo).',
    testing: 'Testando…',
    testConnection: 'Testar conexão',
    syncDescription: 'Ao ativar a sincronização, suas anotações, resumos, traduções e progresso se fundem automaticamente entre dispositivos (CRDT). Os arquivos EPUB são enviados sob demanda.',
    autoUploadOnImport: 'Enviar automaticamente para a nuvem ao importar',
    autoUploadOnImportHint: 'Cada EPUB que você importar será enviado para a nuvem em segundo plano (se houver sessão).',
    configured: 'Credenciais configuradas (via ambiente)',
  },
  auth: {
    signIn: 'Entrar',
    signUp: 'Registrar',
    signOut: 'Sair',
    email: 'Email',
    password: 'Senha',
    sessionStarted: 'Sessão iniciada',
    accountCreated: 'Conta criada',
    profile: 'Perfil',
    editProfile: 'Editar perfil',
    profileSaved: 'Perfil guardado.',
    avatar: 'Avatar',
    avatarUpdated: 'Avatar atualizado.',
    displayName: 'Nome público',
    displayNamePlaceholder: 'O seu nome (visível no feed e livros partilhados)',
    bio: 'Biografia',
    bioPlaceholder: 'Conte aos outros leitores sobre si…',
    noBio: 'Sem biografia.',
    makePublic: 'Perfil público (visível para outros leitores)',
    publicProfile: 'Perfil público',
    inviteCode: 'Código de convite',
    inviteCodePlaceholder: 'EPUB-XXXXXX-XXXXXX',
    inviteCodeInvalid: 'Código inválido, expirado ou já usado.',
    inviteCodeValid: 'Código válido.',
    inviteCodeRequired: 'Precisa de um código de convite válido para se registar.',
    confirmEmail: 'Verifique seu email para confirmar a conta.',
    sessionClosed: 'Sessão encerrada.',
    modeLogin: 'login',
    modeSignup: 'registro',
    haveAccount: 'Já tem conta? Entre',
    noAccount: 'Não tem conta? Registre-se',
    sessionActive: 'Sessão iniciada',
    goToLibrary: 'Ir para a biblioteca',
    createTitle: 'Criar conta',
    signinSubtitle: 'Sincronize sua biblioteca, anotações e resumos entre dispositivos.',
    emailPlaceholder: "seu{'@'}email.com",
    passwordPlaceholder: '••••••••',
    processing: 'Processando…',
    signInShort: 'Entrar',
    signUpShort: 'Registrar',
    noAccountShort: 'Sem conta?',
    haveAccountShort: 'Já tem conta?',
    signUpLink: 'Registre-se',
    signInLink: 'Entre',
    continueWithoutSync: 'Continuar sem sincronizar',
    memberSince: 'Membro desde {date}',
    syncActive: 'Sincronização ativa',
    syncInactive: 'Sem sincronizar',
    syncStatusHint: 'Seus livros, anotações e estantes são salvos na nuvem.',
    syncOffHint: 'Seus dados vivem apenas neste dispositivo. Ative a sincronização em Ajustes para backups.',
    goToSyncSettings: 'Ajustes de sincronização',
    forgotPassword: 'Esqueceu sua senha?',
    resetPasswordTitle: 'Recuperar senha',
    resetPasswordHint: 'Enviaremos um e-mail com instruções para redefini-la.',
    resetPasswordSent: 'Verifique sua caixa de entrada: enviamos instruções para recuperar sua senha.',
    resetPasswordCancel: 'Voltar',
    sendResetLink: 'Enviar link',
    aiLockedTitle: 'Config de IA bloqueada',
    aiLockedHint: 'Digite sua senha para sincronizar suas configurações de IA entre dispositivos.',
    unlock: 'Desbloquear',
    unlocking: 'Desbloqueando…',
    unlocked: 'Configuração de IA desbloqueada e sincronizada.',
    confirmPassword: 'Repetir senha',
    confirmPasswordPlaceholder: '••••••••',
    passwordMismatch: 'As senhas não coincidem.',
    showPassword: 'Mostrar senha',
    hidePassword: 'Ocultar senha',
    passwordStrengthWeak: 'fraca',
    passwordStrengthFair: 'razoável',
    passwordStrengthStrong: 'forte',
    emailInvalid: 'E-mail inválido.',
    whatSyncGives: 'O que você ganha ao sincronizar',
    syncBenefitLibrary: 'Sua biblioteca em todos os seus dispositivos',
    syncBenefitAnnotations: 'Anotações e resumos sempre disponíveis',
    syncBenefitShelves: 'Estantes e cartões de revisão sincronizados',
    syncBenefitBackup: 'Backup automático na nuvem',
  },
  stats: {
    title: 'Estatísticas',
    wrappedTitle: 'Seu ano {year}',
    wrappedHours: 'Horas de leitura',
    wrappedDays: 'Dias lidos',
    wrappedStreak: 'Maior sequência',
    wrappedBooksRead: 'Livros lidos',
    wrappedBooksFinished: 'Livros terminados',
    wrappedHighlights: 'Anotações',
    wrappedTopBook: 'Livro mais lido',
    wrappedColors: 'Anotações por cor',
    totalTime: 'Tempo total',
    currentStreak: 'Sequência atual',
    streakDays: 'dias',
    reading: 'Lendo',
    finished: 'Lidos',
    last14Days: 'Últimos 14 dias',
    mostRead: 'Mais lidos',
    unknown: 'Desconhecido',
    empty: 'Sem dados ainda. Abra um livro e comece a ler para ver suas estatísticas.',
    dailyGoal: 'Meta diária',
    goalTarget: 'Objetivo',
    goalMinutes: 'min',
    goalMet: 'Meta atingida! 🎉',
    goalRemaining: 'Faltam {minutes} min.',
    goalSetHint: 'Defina uma meta para se motivar.',
    today: 'hoje',
  },
  settings: {
    title: 'Configurações',
    appearance: 'Aparência',
    theme: 'Tema',
    themeDark: 'Escuro',
    themeLight: 'Claro',
    themeSepia: 'Sépia',
    highlightColors: 'Cores dos sublinhados',
    appMode: 'Modo do app',
    appModeHint: 'Aparência da interface. Independente do tema do leitor.',
    modeLight: 'Claro',
    modeDark: 'Escuro',
    modeSystem: 'Sistema',
    language: 'Idioma',
    typography: 'Tipografia',
    fontFamily: 'Fonte',
    fontSize: 'Tamanho',
    lineHeight: 'Espaçamento',
    margin: 'Margem',
    letterSpacing: 'Espaçamento de letras',
    wordSpacing: 'Espaçamento de palavras',
    paragraphSpacing: 'Espaçamento de parágrafos',
    accessibility: 'Acessibilidade',
    dyslexicFont: 'Fonte OpenDyslexic',
    bionicReading: 'Leitura biónica',
    bionicWarning: 'A leitura biónica pode deslocar as anotações existentes nessa secção.',
    ttsHighlight: 'Realce ao ler em voz alta',
    keepScreenAwake: 'Manter ecrã aceso ao ler',
    keepScreenAwakeHint: 'Evita que o protetor de ecrã seja ativado enquanto lê. Consome mais bateria.',
    readingGoals: 'Metas de leitura',
    dailyGoal: 'Meta diária (min)',
    sync: 'Sincronização',
    ai: 'Inteligência artificial',
    about: 'Sobre',
    diagnostics: 'Diagnóstico',
    backup: 'Cópia de segurança',
    backupHint: 'Exporte toda a sua biblioteca (livros, anotações, progresso) para um arquivo .epubu. Não inclui suas chaves de API nem credenciais.',
    backupExport: 'Exportar biblioteca',
    backupImport: 'Importar biblioteca',
    backupExportDone: 'Biblioteca exportada.',
    backupExportFailed: 'Não foi possível exportar: {reason}',
    backupImportDone: 'Importado(s) {books} livro(s) e {annotations} anotação(ões). {skipped} duplicado(s) ignorado(s).',
    backupImportFailed: 'Não foi possível importar: {reason}',
    version: 'Versão',
  },
  pwa: {
    updateAvailable: 'Há uma nova versão disponível.',
    reload: 'Recarregar',
    offlineReady: 'Pronto para usar offline.',
  },
  errors: {
    generic: 'Algo deu errado.',
    network: 'Erro de rede.',
    notFound: 'Não encontrado.',
    invalid: 'Inválido.',
    quota: 'Sem espaço de armazenamento. Remova livros antigos.',
    bookNotFound: 'Livro não encontrado.',
    openBookFailed: 'Não foi possível abrir o livro: {reason}',
    searchFailed: 'Busca falhou: {reason}',
    settingsCorrupt: 'Configurações corrompidas; usando padrões.',
  },
  notif: {
    title: 'Notificações',
    empty: 'Não tem notificações.',
    markAllRead: 'Marcar todas como lidas',
    generic: 'Tem uma nova notificação.',
    shareInvited: '{sharer} partilhou um livro consigo.',
    memberJoined: '{name} juntou-se a um livro partilhado.',
    highlightCommented: '{author} comentou numa das suas anotações.',
    newFollower: '{name} segue-o.',
  },
  profile: {
    anonymous: 'Anónimo',
    notFound: 'Perfil não encontrado ou privado.',
    follow: 'Seguir',
    unfollow: 'Deixar de seguir',
    followingToast: 'Agora segue este utilizador.',
    unfollowed: 'Deixou de seguir este utilizador.',
    followers: 'seguidores',
    following: 'a seguir',
    editOwn: 'Editar',
    placeholder: 'Brevemente: citações e livros públicos deste leitor.',
  },
  clubs: {
    title: 'Clubes de leitura',
    subtitle: 'Leia e debata em grupo.',
    new: 'Novo clube',
    create: 'Criar clube',
    created: 'Clube criado.',
    createFailed: 'Não foi possível criar o clube.',
    name: 'Nome',
    description: 'Descrição',
    empty: 'Ainda não há clubes. Crie o primeiro.',
    join: 'Aderir',
    leave: 'Sair',
    joined: 'Aderiu ao clube.',
    left: 'Saiu do clube.',
    members: 'Membros',
    membersCount: 'membros',
    books: 'Livros do clube',
    noBooks: 'Ainda não há livros neste clube.',
    notFound: 'Clube não encontrado.',
  },
  moderation: {
    title: 'Moderação',
    subtitle: 'Reveja denúncias e oculte citações inadequadas.',
    tabReports: 'Denúncias',
    tabHidden: 'Ocultos',
    noReports: 'Sem denúncias abertas.',
    noHidden: 'Sem citações ocultas.',
    resolved: 'Denúncia resolvida.',
    dismissed: 'Denúncia ignorada.',
    hidden: 'Citação ocultada.',
    unhidden: 'Citação visível novamente.',
    unhide: 'Mostrar',
  },
  invitations: {
    title: 'Convites',
    subtitle: 'Gere códigos de uso único para convidar novos utilizadores.',
    generate: 'Gerar código',
    created: 'Código gerado.',
    createFailed: 'Não foi possível gerar o código.',
    code: 'Código',
    status: 'Estado',
    reservedFor: 'Reservado para',
    usedBy: 'Usado por',
    expires: 'Expira',
    note: 'Nota',
    notePlaceholder: 'Para quem é este código (opcional)',
    revoke: 'Revogar',
    revokeConfirm: 'Revogar este código? Deixará de poder ser usado.',
    revoked: 'Código revogado.',
    copyLink: 'Copiar ligação',
    copyCode: 'Copiar código',
    linkCopied: 'Ligação copiada para a área de transferência.',
    codeCopied: 'Código copiado.',
    empty: 'Ainda não há códigos. Gere o primeiro acima.',
  },
  admin: {
    title: 'Administração',
    backToApp: 'Voltar ao app',
    nav: {
      overview: 'Resumo',
      users: 'Usuários',
      events: 'Eventos',
      email: 'Email',
      audit: 'Auditoria',
      moderation: 'Moderação',
      invitations: 'Convites',
      system: 'Sistema',
    },
    overview: {
      title: 'Visão geral',
      subtitle: 'Métricas de uso agregadas de todo o app.',
      totalUsers: 'Usuários totais',
      activeToday: 'Ativos hoje',
      active7d: 'Ativos 7d',
      active30d: 'Ativos 30d',
      newUsers30d: 'Novos (30d)',
      cloudBooks: 'Livros na nuvem',
      readingTime: 'Tempo de leitura',
      aiTokens: 'Tokens IA',
      last90d: 'últimos 90 dias',
      activityTitle: 'Atividade (últimos 30 dias)',
      providerUsage: 'Uso de provedores IA',
      requests: 'req.',
      tokens: 'tokens',
    },
    users: {
      title: 'Usuários',
      subtitle: '{n} usuário(s) registrado(s) | {n} usuário registrado | {n} usuários registrados',
      searchPlaceholder: 'Buscar por email…',
      colEmail: 'Email',
      colRole: 'Papel',
      colCreated: 'Registro',
      colLastSeen: 'Última atividade',
      colActions: 'Ações',
      you: 'você',
      bannedBadge: 'suspenso',
      empty: 'Sem resultados.',
      justNow: 'agora mesmo',
      minAgo: 'há {n} min',
      hourAgo: 'há {n} h',
      dayAgo: 'há {n} d',
      actions: {
        promote: 'Promover a admin',
        demote: 'Remover admin',
        ban: 'Suspender',
        unban: 'Reativar',
        'promote.done': 'Usuário promovido a administrador.',
        'demote.done': 'Direitos de admin removidos.',
        'ban.done': 'Usuário suspenso.',
        'unban.done': 'Usuário reativado.',
      },
      confirm: {
        promote: { title: 'Promover a administrador', body: 'Este usuário poderá ver todos os dados e gerenciar o app. Confirmar?' },
        demote: { title: 'Remover direitos de admin', body: 'O usuário perderá acesso ao painel de administração.' },
        ban: { title: 'Suspender usuário', body: 'O usuário não poderá entrar até ser reativado.' },
        unban: { title: 'Reativar usuário', body: 'O usuário poderá entrar novamente.' },
      },
    },
    events: {
      title: 'Eventos',
      subtitle: 'Feed de eventos para depuração e métricas.',
      filterType: 'Tipo',
      filterUser: 'Usuário (UUID)',
      allTypes: 'Todos os tipos',
      userUuidPlaceholder: 'UUID completo',
      colTime: 'Data',
      colType: 'Tipo',
      colUser: 'Usuário',
      colProps: 'Dados',
      empty: 'Sem eventos para esses filtros.',
      showing: 'Mostrando {n} evento(s).',
    },
    email: {
      title: 'Email transacional',
      subtitle: 'Integração com Resend para Auth e notificações.',
      statusTitle: 'Status da integração',
      smtpTransport: 'Auth SMTP (Supabase)',
      smtpHint: 'Configure no painel do Supabase → Auth → SMTP',
      edgeFunction: 'Edge Function (Resend API)',
      noSupabase: 'Supabase não configurado em Ajustes',
      setupHint: 'Veja o guia de configuração em',
      testTitle: 'Enviar teste',
      recipient: 'Destinatário',
      sendTest: 'Enviar email de teste',
      testSent: 'Email enviado (verifique a caixa e o histórico).',
      enterRecipient: 'Indique um email de destino.',
      configSyncFirst: 'Configure o Supabase em Ajustes → Sincronização para ativar o envio.',
      broadcastTitle: 'Broadcast para usuários',
      broadcastHint: 'Envia um modelo para todos os usuários ativos. Somente administradores.',
      broadcastTemplate: 'Modelo',
      broadcastVars: 'Variáveis (JSON)',
      broadcastActiveDays: 'Somente ativos nos últimos',
      broadcastDays: 'dias (0 = todos)',
      sendBroadcast: 'Enviar broadcast',
      broadcastOk: 'Broadcast enviado para {n} destinatário(s).',
      broadcastPartial: 'Enviados: {ok}. Falhas: {fail}. Veja o histórico.',
      broadcastResult: '✓ {sent} enviados · {failed} falhas',
      invalidVars: 'JSON de variáveis inválido.',
      history: 'Histórico de envios',
      colWhen: 'Data',
      colTo: 'Para',
      colTemplate: 'Modelo',
      colStatus: 'Status',
      noLogs: 'Nenhum email enviado ainda.',
    },
    audit: {
      title: 'Auditoria',
      subtitle: 'Registro de ações administrativas.',
      colWhen: 'Data',
      colActor: 'Ator',
      colAction: 'Ação',
      colTarget: 'Alvo',
      colMeta: 'Detalhe',
      empty: 'Sem ações registradas.',
    },
    system: {
      title: 'Sistema',
      subtitle: 'Estado da conexão com o banco de dados (Supabase). Somente leitura.',
      host: 'Host do projeto',
      credentialsSource: 'Credenciais',
      viaEnv: 'Injetadas no build (variáveis de ambiente)',
      note: 'As credenciais são definidas no deploy e não são exibidas nem editadas aqui. Esta vista apenas informa o estado da conexão.',
    },
  },
}
